import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, ComponentRef, ViewContainerRef } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CurrentUserModel } from '../models/account-ledger.model';
import { ChatBotComponent } from '../nav/nav-components/chat-bot/chat-bot.component';
import { EventListenerService } from '../services/close-listenenr.service';
import { CommonService } from '../services/common.service';
import { DDAIService } from '../services/dd-ai.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'child-header',
  templateUrl: './child-header.component.html',
  styleUrls: ['./child-header.component.css']
})
export class ChildHeaderComponent implements OnInit {
  isChecked: boolean = false;
  @Input() title = '';
  @Input() titleIcon = '';
  @Input() showLoading = false;
  @Input() disableDownload = false;
  @Input() disableUpload = false;
  @Input() disableUploadBulkOrder = false;
  @Input() menu = {};

  @Input() buttonCollapse = false;
  @Input() showDownload = false;
  @Input() showUpload = false;
  @Input() showUploadBulkOrder = false;
  @Input() showBulkTransfer = false;
  @Input() showAdd = false;
  @Input() showAddUser = false;
  @Input() showAssociate = false;
  @Input() showMigrate = false;
  @Input() showBulkMigrate = false;
  @Input() showEdit = false;
  @Input() showDelete = false;
  @Input() showClone = false;
  @Input() showDDAI = false;
  @Input() disableAdd = false;
  @Input() titleDownload = "";
  @Input() titleUpload = "";
  @Input() titleUploadBulkOrder = "";
  @Input() titleBulkTransfer = "";
  @Input() tooltipDownload = "";
  @Input() tooltipUpload = "";
  @Input() tooltipUploadBulkOrder = "";
  @Input() tooltipBulkTransfer = "";
  @Input() titleAdd = "";
  @Input() titleAddUser = "";
  @Input() tooltipAddUser = "";
  @Input() tooltipAdd = '';
  @Input() titleAssociate = "";
  @Input() titleMigrate = "";
  @Input() titleBulkMigrate = "";
  @Input() tooltipAssociate = "";
  @Input() titleEdit = "";
  @Input() titleClone = "";
  @Input() titleDelete = "";
  @Input() tooltipDisabledAdd = false;
  @Input() menuDownloadItems = [];
  @Input() showSubscription = false;
  @Input() editMode = false;
  @Output() closeEvent = new EventEmitter<void>();
  @Output() downloadEvent = new EventEmitter<void>();
  @Output() uploadEvent = new EventEmitter<void>();
  @Output() uploadEventBulkOrder = new EventEmitter<void>();
  @Output() uploadEventBulkTransfer = new EventEmitter<void>();
  @Output() addEvent = new EventEmitter<void>();
  @Output() addUserEvent = new EventEmitter<void>();
  @Output() associateEvent = new EventEmitter<void>();
  @Output() migrateEvent = new EventEmitter<void>();
  @Output() bulkMigrateEvent = new EventEmitter<void>();
  @Output() cloneEvent = new EventEmitter<void>();
  @Output() deleteEvent = new EventEmitter<void>();
  @Output() editEvent = new EventEmitter<string>();
  @Output() menuDownloadEvent = new EventEmitter<string>();
  @Output() subscriptionEvent = new EventEmitter<void>();
  isEditMode: boolean = false;
  isStaffAccount: boolean = false;
  //loginId:string;
  purchaseAccess: boolean = false;
  adminAccess: boolean = false;
  ddaiButton: boolean = false;
  component: ComponentRef<any>;
  closesub$;

  constructor(
    private router: Router,
    private authService: AuthService,
    private closeListener: EventListenerService,
    private ddaiService: DDAIService,
    public commonService: CommonService
  ) {
  }

  ngOnInit() {

    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.isStaffAccount = res.isStaffAccount;
      //this.loginId = res.loginId;   
      this.adminAccess = res.hasAdminAccess;
      this.purchaseAccess = res.hasPurchaseAccess;
    },
      (error: any) => {
        console.info(error);
      });
  }
  onEditMode(event: MatSlideToggleChange): void {
    this.isEditMode = event.checked;
    if (this.isEditMode) {
      this.router.navigateByUrl('/catalogueedit');
    }
    else {
      this.router.navigateByUrl('/catalogues');
    }
  }
  close() {
    this.closeEvent.next();
  }
  onDownload() {
    this.downloadEvent.next();
  }
  onUpload() {
    this.uploadEvent.next();
  }
  onUploadBulkOrder() {
    this.uploadEventBulkOrder.next();
  }
  onUploadBulkTransfer() {
    this.uploadEventBulkTransfer.next();
  }
  onAdd() {
    this.addEvent.next();
  }
  onAssociate() {
    this.associateEvent.next();
  }
  onMigrate() {
    this.migrateEvent.next();
  }
  onBulkMigrate() {
    this.bulkMigrateEvent.next();
  }
  onAddUser() {
    this.addUserEvent.next();
  }
  onEdit() {
    this.editEvent.next();
  }
  onClone() {
    this.cloneEvent.next();
  }
  onDelete() {
    this.deleteEvent.next();
  }
  onSubscription() {
    this.subscriptionEvent.next();
  }
  onMenuDownload(menu: string) {
    this.menuDownloadEvent.next(menu);
  }

  ddaiToggle = () => {
    this.ddaiService.toggleDDAI$.next();
  }

  reset() {
  }
}
